import { useApi } from './use-api';
import { worklogService } from '../services/worklog.service';

export function useWorklog(projectId: string | undefined) {
  const { loading, result: worklog, error } = useApi(worklogService.get, projectId);
  return { loading, worklog, error };
}
